import script from "./CreateNewSubAccountModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateNewSubAccountModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateNewSubAccountModal.vue?vue&type=style&index=0&id=3638c42c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3638c42c"]])

export default __exports__